import React, { useContext } from "react";
import { Box, Heading } from "@chakra-ui/react";
import { AuthContext } from "../context/AuthContext";
import UserTable from "../components/users/UserTable";

const UsersPage = () => {
    const { currLocation } = useContext(AuthContext);

    return (
        <Box
            as="main"
            pt={{ base: "24px", md: "20px" }}
            pl={{ base: "0px", md: "240px" }}
            pr={{ base: "0px", md: "30px" }}
            pb="20px"
            minH="100vh"
        >
            <UserTable locationId={currLocation} />
        </Box>
    );
};

export default UsersPage;
